import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// import AsyncStorage from '@react-native-async-storage/async-storage';

const firebaseConfig = {
    apiKey: "AIzaSyASOGFBo7p4blZbWas7B6_FuSX8G54ssbs",
    authDomain: "myconcours-ec9cb.firebaseapp.com",
    projectId: "myconcours-ec9cb",
    storageBucket: "myconcours-ec9cb.firebasestorage.app",
    messagingSenderId: "165784238659",
    appId: "1:165784238659:web:9c4593682c3fc2e682b2f6",
    measurementId: "G-HB3K0PY0HS"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);

const db = getFirestore(app);

export { auth, db, storage };
export default app;